import MainLayout from "../components/layouts/MainLayout";
import RegistrationForm from "../components/forms/RegistrationForm";

const RegistrationPage = () => {
    return <>
        <MainLayout>
            <RegistrationForm/>
        </MainLayout>
    </>
}

export default RegistrationPage